<template>
  <div style="display: flex">
    <div class="header-menu" v-loading.fullscreen.lock="loading">
      <div style="margin:0 auto">
        <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
          <div style="display: flex;">
            <h1 style="color: #409EFF;text-decoration:none">{{ $t('HangKnife') }}</h1>
            <el-menu
              :default-active="activeRouter"
              router
              class="el-menu-demo"
              mode="horizontal"
            >
              <el-menu-item index="/Home">{{ $t('Home') }}</el-menu-item>
<!--              <el-menu-item index="/Inventory">{{ $t('Inventory') }}</el-menu-item>-->
              <!--              <el-menu-item index="/Api">{{ $t('Api') }}</el-menu-item>-->
              <!--              <el-menu-item index="/MobileHome">移动端</el-menu-item>-->
<!--              <el-menu-item index="/DisCountHistory">挂刀趋势</el-menu-item>-->
              <el-menu-item index="/TradeUp">{{ $t('Trade Up') }}</el-menu-item>
              <el-menu-item index="/Tools">实用工具</el-menu-item>
            </el-menu>
          </div>
          <div class="avatarDiv">
            <el-select v-model="language" style="width: 155px" @change="changeLanguage" size="small">
              <el-option :key="'zh'" label="中文" value="zh">
                <div class="DropdownElement" style="min-height:38px" id="zh">
                  <img src="static/imgs/zh.svg" style="height: 20px;width: 20px;vertical-align: -12%;margin-right: 12px" alt="zh">中文
                </div>
              </el-option>
              <el-option :key="'en'" label="English" value="en">
                <div class="DropdownElement" style="min-height:38px" id="zh">
                  <img src="static/imgs/en.svg" style="height: 20px;width: 20px;vertical-align: -12%;margin-right: 12px"
                       alt="zh">English
                </div>
              </el-option>
            </el-select>
            <el-select v-model="currency" @change="changeCurrency"
                       style="color: #fcf5e8;font-size: .875rem;font-weight: 700;width: 95px" size="small">
              <el-option :key="'CNY'" label="CNY" value="CNY" id="CNY">
              </el-option>
              <el-option :key="'USD'" label="USD" value="USD" id="USD">
              </el-option>
              <el-option :key="'AUD'" label="AUD" value="AUD" id="AUD">
              </el-option>
              <el-option :key="'EUR'" label="EUR" value="EUR" id="EUR">
              </el-option>
              <el-option :key="'RUB'" label="RUB" value="RUB" id="RUB">
              </el-option>
              <el-option :key="'TRY'" label="TRY" value="TRY" id="TRY">
              </el-option>
              <el-option :key="'JPY'" label="JPY" value="JPY" id="JPY">
              </el-option>
              <el-option :key="'HKD'" label="HKD" value="HKD" id="HKD">
              </el-option>
              <el-option :key="'CAD'" label="CAD" value="CAD" id="CAD">
              </el-option>
            </el-select>
            <!--            <el-button @click="steamLogin" type="primary" size="small" v-if="!login" style="margin-left: 8px;">-->
            <!--              {{ $t('loginButton') }}-->
            <!--            </el-button>-->
<!--            <el-button @click="loginViaSteam" type="primary" size="small" v-if="!login" style="margin-left: 8px;">-->
<!--              {{ $t('loginButton') }}-->
<!--            </el-button>-->
<!--            <div v-else>-->
<!--              <el-dropdown trigger="hover" @command="handleCommand" style="margin-top: 4px;margin-left: 8px;">-->
<!--                &lt;!&ndash;                @click="$router.push('/Account')"&ndash;&gt;-->
<!--                <div class="userAvatar">-->
<!--                  <div style="display: inline-block">-->
<!--                    <el-avatar src="static/imgs/logo.avator.png"></el-avatar>-->
<!--                  </div>-->
<!--                  <div style="text-align: center">-->
<!--                    <div style="display: inline-block;margin-left: 12px;">-->
<!--                      {{ login ? userInfo.name : '' }}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <el-dropdown-menu slot="dropdown">-->
<!--                  <div-->
<!--                    style="display: block; height: 1px; width: 100%; margin: 8px 0px; background-color: rgb(220, 223, 230); position: relative;"></div>-->
<!--                  <el-dropdown-item command="account">-->
<!--                    <div style="text-align: center">-->
<!--                      {{ $t('Steam Balance') }} : {{ getSteamBalance() }}-->
<!--                    </div>-->
<!--                  </el-dropdown-item>-->
<!--                  <div-->
<!--                    style="display: block;height: 1px;width: 100%;margin: 8px 0;background-color: #dcdfe6;position: relative;"></div>-->
<!--                  <el-dropdown-item command="logOut">-->
<!--                    <div style="text-align: center">-->
<!--                      <i class="el-icon-switch-button"></i>-->
<!--                      {{ $t('Log Out') }}-->
<!--                    </div>-->
<!--                  </el-dropdown-item>-->
<!--                </el-dropdown-menu>-->
<!--              </el-dropdown>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  allCurrencyOptions,
  logOff
} from "../../api/api";
import store from "../../store";
import i18n from "../../main";
import {cloneObj} from "../../api/util";

const {loginSteamCommunityConfirm} = require("../../api/api");

export default {
  name: "menuBar",
  data() {
    return {
      activeRouter: 'Home',
      loading: false,
      language: this.$i18n.locale,
      currency: localStorage.getItem("selectedCurrency"),
    }
  },
  computed: {
    login() {
      let steamId = this.$store.getters.getUserInfo.steamId
      if (steamId) {
        return true
      } else {
        return false
      }
    },
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  methods: {
    loginViaSteam() {
      // 第三方登录
      // let loginUrl = 'http://localhost:3000'
      let loginUrl = 'http://www.hangKnife.com/oauthNode'
      let steamLoginUrl = `https://steamcommunity.com/openid/login?openid.mode=checkid_setup&openid.claimed_id=http://specs.openid.net/auth/2.0/identifier_select&openid.identity=http://specs.openid.net/auth/2.0/identifier_select&openid.ns=http://specs.openid.net/auth/2.0&openid.realm=${loginUrl}&openid.return_to=${loginUrl}/steam/oauthCallback`
      window.open(steamLoginUrl, '_parent', 'width=650,height=700,top=25,left=50')
    },
    getSteamBalance() {
      return this.$store.getters.getUserInfo.wallet == null ? 0 : this.$store.getters.getUserInfo.wallet.balance
    },
    handleCommand(val) {
      switch (val) {
        case 'account':
          this.$router.push('/Account')
          break;
        case 'logOut':
          logOff({}).then(json => {
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('authCode')
            localStorage.removeItem("steamId")
            localStorage.removeItem("session")
            localStorage.removeItem("cookies")

            store.commit('clearUserInfo');
            store.commit('setLogin', false)
            this.loginStatus = 'Logining....'
            this.$message({
              message: '注销成功',
              type: 'success'
            });
          })
          break;
        default:
          return;
      }
    },
    // handleMessageFromIframe(event) {
    //   // 在这里处理来自iframe的消息
    //   if (event.data.type !== undefined && event.data.type === 'tryLogin') {
    //     this.loading = true
    //   }
    //   // event.data包含了iframe发送的消息内容
    //   // 根据消息内容执行相应的操作
    //   if (event.data.loginFlag !== undefined) {
    //     if (event.data.loginFlag === 'T') {
    //       // 塞token到浏览器中
    //       localStorage.setItem('refreshToken', event.data.loginData.refresh_token);
    //       // 换用户信息
    //       getUserInfo({access_token: event.data.loginData.access_token}).then(json => {
    //         if (json.data.flag === 'T') {
    //           localStorage.setItem('user', JSON.stringify(json.data.data.userInfo));
    //           store.commit('setUserInfo', json.data.data.userInfo); // 使用Vuex保存用户信息
    //           // 刷新页面
    //           this.loginDialog = false
    //         } else {
    //           ElementUI.Message.error(json.data.errorMsg);
    //           localStorage.removeItem('refreshToken');
    //           store.commit('clearUserInfo');
    //         }
    //       }).finally(_ => {
    //         this.loading = false
    //       })
    //     }
    //   }
    // },
    getUserAvator() {
      return this.$store.state.userAvatar
    },
    getUserName() {
      return this.$store.getters.getUserName
    },
    changeLanguage(language) {
      // 通过 $i18n 对象的方法来切换语言
      this.$i18n.locale = language;

      // 如果你将语言选择存储在 localStorage 中，可以更新 localStorage 中的值
      localStorage.setItem('selectedLanguage', language);
    },
    changeCurrency(currency) {
      store.commit('setCurrency', currency); // 使用Vuex保存货币
      localStorage.setItem("selectedCurrency", currency);
    },
  },
  created() {
    this.activeRouter = this.$route.path
    allCurrencyOptions().then(json => {
      let options = cloneObj(json.data.data)
      options.CNY = "1"
      this.$store.commit('setCurrencyOptions', options)
    })
  }
}
</script>

<style scoped>

.header-menu {
  flex: 1;
  text-align: center;
  position: relative;
  height: 60px;
  width: 100%;
  min-width: 1200px;
  border-bottom: 1px solid #dcdfe6;
}

.header-menu h1 {
  font-size: 26px;
  color: #409EFF;
  font-weight: 400;
  margin: 0px;
  padding: 12px 0px;
  min-width: 210px;
}

.routerLink a {
  text-decoration: none
}

.drop-store {
  width: 238px;
  min-height: 160px;
  background: #3a4452;
  border: 1px solid #282F39;
  box-shadow: 0 5px 10px 0 rgb(0 0 0 / 20%);
  border-radius: 2px;
  line-height: 1em !important;
  z-index: 104;
}

.store-user {
  padding: 20px;
  background: #313a45;
  font-size: 0;
}

.user-title {
  float: right;
  height: 42px;
  width: 60%;
  padding: 5px;
  color: #E4E8EE;
  vertical-align: middle;
  max-width: 122px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.userTriggerTittle {
  float: right;
  position: relative;
  line-height: 46px;
  display: flex;
}

.userTriggerTittle:hover {
  cursor: pointer;
}

.routerTab {
  font-weight: 400;
  display: inline-block;
  cursor: pointer;
}


iframe {
  border: none; /* 移除 iframe 的边框 */
  margin: 0; /* 移除 iframe 的外边距 */
  padding: 0; /* 移除 iframe 的内边距 */
}

.userAvatar {
  display: flex;
  align-items: center;
}

.userAvatar:hover {
  cursor: pointer;
}

.avatarDiv {
  margin-right: 12px;
  min-width: 280px;
  line-height: 19px;
  align-items: center;
  display: flex;
}

.login-other {
  font-size: 12px;
  color: #959595;
  text-align: center;
  background: #f0f0f0;
  padding: 10px 0;
  position: relative;
  z-index: 99;
  border-radius: 12px;
}

</style>

<style>

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}

.loginDialog {
  padding: 0px;
  border-radius: 12px;
}

.loginDialog .el-dialog__body {
  padding: 0px !important;
}

.loginDialog .el-dialog__header {
  display: none;
}

/**写样式要注意，写在不带scoped的 style 里 修改下面的小三角，属性名根据组件的placement位置做相应修改 */
.userPopper[x-placement^='left'] .popper__arrow::after {
}

.userPopper[x-placement^='right'] .popper__arrow::after {
}

.userPopper[x-placement^='bottom'] .popper__arrow::after {
}

.userPopper[x-placement^='top'] .popper__arrow::after {
}


/*修改title的颜色*/
.userPopper .el-popover__title {
}

.userPopper {
  font-size: 18px;
  padding: 0px;
  background: none;
}

.el-menu-demo {
  min-width: 170px;
}

.DropdownElement {
  display: flex;
  align-items: center;
  min-height: 30px;
  padding: 0 10px;
  font-size: 14px;
  line-height: 100%;
  white-space: nowrap;
  cursor: pointer;
  border-radius: 2px;
  transition: all .2s cubic-bezier(.4, 0, .2, 1);
}
</style>



// WEBPACK FOOTER //
// src/ui/Menu/menuBar.vue